// Application entry point
import "./styles/reset.css";
import "./styles/variables.css";
import "./styles/global.css";
import "./styles/layout.css";
import "./styles/diagram.css";
import "./styles/info-panel.css";
import "./styles/title-overlay.css";
import "./styles/locale-switcher.css";
import "./styles/logo.css";

import { App } from "./app";

// Initialize application
const app = new App();
app.init();
